// extracted by mini-css-extract-plugin
export var dividerContainer = "_a1-0";
export var line = "_a1-1";